module.exports = __webpack_public_path__ + "static/media/onmyway133.345e6c7a.jpeg";